/**
 * CaseFlow+AI - Demo Configuration
 * Phase 4B: Sales-Ready Demo Flow + Pilot Package
 * 
 * Environment variable controlled demo mode.
 * Set VITE_DEMO_MODE=true to enable demo mode.
 */

// Demo mode is enabled by explicit demo build/environment markers.
export const DEMO_MODE =
  import.meta.env.MODE === 'demo' ||
  import.meta.env.VITE_ENVIRONMENT === 'demo' ||
  import.meta.env.VITE_APP_ENVIRONMENT === 'demo' ||
  import.meta.env.VITE_APP_ENV === 'demo' ||
  import.meta.env.VITE_DEMO_MODE === 'true';

export const PILOT_TEST_ACCOUNT_ENABLED =
  import.meta.env.MODE === 'pilot' ||
  import.meta.env.VITE_ENVIRONMENT === 'pilot' ||
  import.meta.env.VITE_APP_ENVIRONMENT === 'pilot' ||
  import.meta.env.VITE_APP_ENV === 'pilot';

export const PILOT_TEST_ACCOUNT_EMAIL = 'test@caseflow.demo';
export const PILOT_ADMIN_ACCOUNT_EMAIL = 'admin@caseflow.demo';

// === DEMO SESSION STORAGE KEYS (centralized) ===
// These constants MUST be imported by any file that reads/writes demo session data.
// Never use magic strings for demo storage keys.

/** localStorage key for the serialized demo session */
export const DEMO_SESSION_KEY = 'utilitydezk_demo_session';

/** localStorage key for the demo user object */
export const DEMO_USER_KEY = 'utilitydezk_demo_user';

/** localStorage key for the demo organization object */
export const DEMO_ORGANIZATION_KEY = 'utilitydezk_demo_organization';

/** Current demo session schema version – increment when the DemoSession shape changes */
export const DEMO_SESSION_VERSION = 2;

/** Demo session TTL in ms (24 hours) */
export const DEMO_SESSION_TTL_MS = 24 * 60 * 60 * 1000;

// API configuration for demo mode
export const DEMO_API_CONFIG = {
  // When demo mode is on, use mock services instead of real backend
  useMockServices: DEMO_MODE,
  
  // Demo organization ID - all demo data is scoped to this org
  demoOrganizationId: 'org_demo_001',
  
  // Demo users for simulation (names MUST be unique, not conflict with customer names)
  demoUsers: [
    { id: 'operator_001', name: 'Anna Svensson', role: 'operator' },
    { id: 'operator_002', name: 'Karl Lindström', role: 'operator' },
    { id: 'manager_001', name: 'Lisa Karlsson', role: 'manager' },
  ],
  
  // Feature flags for demo
  features: {
    showAISuggestions: true,
    showTimeline: true,
    showRelations: true,
    showClaims: true,
    showDashboard: true,
    showMissionControl: true,
  },
} as const;

export type DemoUser = typeof DEMO_API_CONFIG.demoUsers[number];
